<template>
  <div id="contratos">
    <div class="div-form">
      <v-form>
        <input
          id="user-id"
          type="hidden"
          v-model="contrato.usuario"
        />
        <input
          id="contrato-id"
          type="hidden"
          v-model="contrato.id"
        />
        <input
          id="contrato-uuid"
          type="hidden"
          v-model="contrato.uuid"
        />
        <input
          id="contrato-uid-processo"
          type="hidden"
          v-model="contrato.uid_processo"
        />
        <input
          id="contrato-nr-processo"
          type="hidden"
          v-model="contrato.nr_processo"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="anoBusca"
              label="Ano da pesquisa"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
            v-if="codigo"
          >
            <v-checkbox
              v-model="contrato.inativar"
              label="Inativar contrato?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
          <v-col
            v-if="ativo != ''"
            cols="12"
            md="6"
            lg="4"
          >
            <h6
              class="info-topo"
              v-show="ativo === 'paralizacao'"
            >Contrato suspenso até {{ dtparalizacao }}</h6>
            <h6
              class="info-topo"
              v-show="ativo === 'rescisao'"
            >Contrato rescindido em {{ dtrescisao }}</h6>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              v-model="codProc"
              name="nr-processo"
              label="Número do Processo:"
              type="text"
              outlined
              dense
              required
              :readonly="mode === 'remove'"
              @change="loadProcesso()"
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadModalProc()"
                class="mr-2"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              v-model="contrato.nr_contrato"
              label="Nº do contrato :"
              type="text"
              outlined
              dense
              required
              :readonly="mode === 'remove'"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="contrato.ano"
              label="Ano do contrato :"
              type="text"
              outlined
              dense
              required
              :readonly="mode === 'remove'"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
            lg="6"
          >
            <v-autocomplete
              clearable
              v-if="mode === 'save'"
              v-model="contrato.orgao"
              :items="gestao"
              label="Gestão do contrato"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-card flat>
          <v-card
            color="grey lighten-5"
            elevation="4"
            tile
          >
            <v-tabs
              background-color="transparent"
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
              color="primary"
              v-model="tabs"
              class="mb-4"
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab>
                <v-icon class="mr-1">
                  mdi-cog-sync
                </v-icon>
                Carga
              </v-tab>'
              <v-tab class="mx-6">
                <v-icon
                  color="success"
                  class="mr-1"
                >
                  mdi-information-outline
                </v-icon>
                Dados do contrato
              </v-tab>
              <v-tab
                class="mx-6"
                @click="loadLicitacao"
              >
                <v-icon
                  color="success"
                  class="mr-1"
                >
                  mdi-hammer
                </v-icon>
                licitação
              </v-tab>
              <v-tab
                :disabled="!contrato.id"
                @click="loadTerceiros"
                class="mx-6"
              >
                <v-icon
                  color="success"
                  class="mr-1"
                >
                  mdi-account-tie
                </v-icon>
                Tercerizados
              </v-tab>
              <v-tab
                :disabled="!contrato.id"
                @click="loadFiscais"
                class="mx-6"
              >
                <v-icon
                  color="success"
                  class="mr-1"
                >
                  mdi-
                </v-icon>
                Responsáveis
              </v-tab>
              <v-tab
                :disabled="!contrato.id"
                class="mx-6"
                @click="loadAditivos"
              >
                <v-icon
                  color="success"
                  class="mr-1"
                >
                  mdi-plus-square
                </v-icon>
                Aditivos
              </v-tab>
              <v-tab :disabled="!contrato.id">
                <v-icon color="danger">
                  mdi-x-square
                </v-icon>
                Distrato
              </v-tab>
              <v-tab
                :disabled="!contrato.id"
                @click="loadAnexos"
              >
                <v-icon color="success">
                  mdi-paperclip
                </v-icon>
                Anexos
              </v-tab>
            </v-tabs>
          </v-card>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  Carregar dados da API Prodata
                  <v-card>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col cols="12" md="6" lg="2">
                            <v-menu v-model="menu9" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-mask="dtini" v-model="data_ini" label="Data inicial.:" dense outlined
                                  @blur="mudaDataJ">
                                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker locale="pt-br" v-model="date9" @input="dateJ">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-menu v-model="menu10" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-mask="dtini" v-model="data_fim" label="Data final.:" dense outlined
                                  @blur="mudaDataK">
                                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker locale="pt-br" v-model="date10" @input="dateK">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-text-field v-model="sync.id" label="Número do conttrato.:" dense outlined hint="215.2025.10" persistent-hint/>
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-text-field v-model="sync.nr_licitacao" label="Processo de compra.:" dense outlined hint="230" persistent-hint/>
                          </v-col>
                          <v-col colls="12" lg="4" md="6" sm="12">
                            <v-autocomplete v-model="sync.gestao" :items="gestCompra"
                              label="Órgçao contratante" dense outlined clearable>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1">
                          <v-col cols="12" md="6">
                            <v-btn color="success" class="ml-1 mr-4" @click="syncDados">
                              <v-icon left>
                                mdi-table-sync
                              </v-icon>
                              Carregar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="mt-4"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          lg="3"
                        >
                          <v-autocomplete
                            clearable
                            v-if="mode === 'save'"
                            v-model="contrato.uid_ajuste"
                            :items="ajuste"
                            label="Tipo de ajuste do contrato"
                            required
                            outlined
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          md="2"
                          lg="3"
                        >
                          <v-menu
                            v-model="menuAs"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="dtass"
                                v-model="assinatura"
                                label="Data assinatura contrato.:"
                                dense
                                outlined
                              >
                                <v-icon
                                  slot="append"
                                  color="success"
                                  large
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              locale="pt-br"
                              v-model="date1As"
                              @input="dateAss"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          md="2"
                          lg="3"
                        >
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="dtini"
                                v-model="inicio"
                                label="Data início contrato.:"
                                dense
                                outlined
                              >
                                <v-icon
                                  slot="append"
                                  color="success"
                                  large
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              locale="pt-br"
                              v-model="date2"
                              @input="dateIn"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          md="2"
                          lg="3"
                        >
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="dttem"
                                v-model="termino"
                                label="Data término contrato"
                                dense
                                outlined
                              >
                                <v-icon
                                  slot="append"
                                  color="success"
                                  large
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              locale="pt-br"
                              v-model="date3"
                              @input="dateFim"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-autocomplete
                            clearable
                            v-if="mode === 'save'"
                            v-model="contrato.uid_tipo_contrato"
                            :items="tpContrato"
                            label="Tipo de contrato"
                            required
                            outlined
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-currency-field
                            v-if="mode === 'save'"
                            v-model="contrato.valor_total"
                            label="Valor do contrato :"
                            dense
                            outlined
                          >
                          </v-currency-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="dtpub"
                                v-model="publicacao"
                                label="Data publicação.:"
                                dense
                                outlined
                              >
                                <v-icon
                                  slot="append"
                                  color="success"
                                  large
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              locale="pt-br"
                              v-model="date1"
                              @input="datePub"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          v-if="codigo"
                        >
                          <v-checkbox
                            v-model="contrato.publicar"
                            label="Publicar contrato?"
                            color="success"
                            v-show="mode === 'save'"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                          lg="2"
                          class="mr-0 pr-0"
                        >
                          <v-text-field
                            class="codigo mr-0"
                            v-model="contrato.uid_pessoa"
                            label="Código..."
                            dense
                            outlined
                            flat
                            @change="loadPedidoPessoaId()"
                          >
                            <v-icon
                              class="v-icon-btn-outer"
                              slot="append-outer"
                              color="white"
                              large
                              @click="loadFtPessoa"
                            >
                              mdi-magnify
                            </v-icon>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                          lg="5"
                          class="mx-0 px-0"
                        >
                          <v-text-field
                            class="v-busca-nome ml-0"
                            v-model="contrato.fornecedor"
                            :loading="loading"
                            aria-autocomplete="none"
                            :search-input.sync="search"
                            label="Nome/ Razão social"
                            outlined
                            dense
                            @keyup.native="loadSeach()"
                          >
                            <v-icon
                              slot="prepend"
                              color="white"
                              @click="loadAddPessoa"
                              class="v-icon-btn"
                              large
                            >
                              mdi-plus
                            </v-icon>
                            <v-icon
                              v-if="contrato.fornecedor"
                              slot="append"
                              color="black"
                              @click.prevent="clPessoa"
                            >
                              mdi-close
                            </v-icon>
                          </v-text-field>
                          <v-card
                            v-show="listar === 'sim'"
                            class="my-0 py-0"
                          >
                            <ul class="filtro">
                              <li
                                v-for="item in items"
                                :key="item.uid_pessoa"
                              >
                                <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.razao }} - {{ item.cgc_txt }}</a>
                              </li>
                            </ul>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          colls="12"
                          lg="12"
                          md="12"
                          sm="12"
                        >
                          <v-textarea
                            v-model="contrato.objetivo"
                            label="Objeto do contrato.:"
                            rows="2"
                            dense
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="mt-4"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          lg="5"
                        >
                          <v-autocomplete
                            clearable
                            v-if="mode === 'save'"
                            v-model="contrato.uid_modal_licitacao"
                            :items="modalidade"
                            label="Modalidade da licitação"
                            required
                            outlined
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          lg="3"
                        >
                          <v-text-field
                            v-model="contrato.nr_licitacao"
                            label="Nº da licitação :"
                            type="text"
                            outlined
                            dense
                            required
                            :readonly="mode === 'remove'"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          lg="3"
                        >
                          <v-text-field
                            v-model="contrato.ano_licitacao"
                            label="Ano da licitação :"
                            type="text"
                            outlined
                            dense
                            required
                            :readonly="mode === 'remove'"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          colls="12"
                          lg="12"
                          md="12"
                          sm="12"
                        >
                          <v-textarea
                            v-model="contrato.ds_razao_escolha_fornecedor"
                            label="Razão da escolha do fornecedor/prestador.:"
                            rows="3"
                            dense
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="mt-4"
                    >
                    <v-card-title>
                      Lista de tercerizados
                    </v-card-title>
                      <v-data-table
                        :headers="headerTercerizados"
                        :items="tercerizados"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-btn icon small color="red" @click="confirmRemove(item)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadModalTercerizado"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Add Tercerizados
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <!-- Responsáveis pelo contrato -->
            <v-tab-item>
              <v-card flat>
                <v-data-table
                  :headers="headerResponsaveis"
                  :items="responsaveis"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadEditResponsavel(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="ml-1 mb-3"
                    v-if="codigo"
                    @click="loadModalResponsavel"
                  >
                    <v-icon left>
                      mdi-archive-arrow-up-outline
                    </v-icon>
                    Add Responsável
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="mt-4"
                    >
                      <v-data-table
                        :headers="headersAditivos"
                        :items="aditivoItems"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAditivo(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="delAditivo(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadModalAditivo"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Add aditivo
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="mt-4"
                    >
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="py-2"
                    >
                      <v-data-table
                        :headers="headerAnexo"
                        :items="anexos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="delDocs(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadModalAnexo"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Add anexo
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row>
          <hr />
          <v-col
            lg="12"
            md="12"
            sm="12"
          >
            <v-btn
              variant="primary"
              v-if="mode === 'save'"
              @click="save"
            >
              Salvar
            </v-btn>
            <v-btn
              variant="danger"
              v-if="mode === 'remove'"
              @click="remove"
            >
              Excluir
            </v-btn>
            <v-btn
              class="ml-2"
              @click="reset"
            >
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <!-- Dialog dos responsáveis do contrato -->
    <v-container>
      <v-dialog
        v-model="dialogResponsavel"
        transition="dialog-top-transition"
      >
        <v-card tile>
          <v-toolbar
            color="primary"
            dark
            class="mb-2"
          >
            Adicionar ou editar responsáveis do contrato
          </v-toolbar>
          <div class="logo-foto ml-4 mt-5">
            <v-form>
              <input
                id="user-id"
                type="hidden"
                v-model="responsavel.usuario"
              />
              <input
                id="uid_processo"
                type="hidden"
                v-model="responsavel.uid_contrato"
              />
              <input
                id="responsavel-id"
                type="hidden"
                v-model="responsavel.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="codResp"
                    label="Código"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                  v-if="codResp"
                >
                  <v-checkbox
                    v-model="responsavel.inativar"
                    label="Inativar responsável?"
                    color="success"
                    class="mt-4"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    v-model="responsavelCod"
                    label="Código..."
                    dense
                    outlined
                    flat
                    @change="loadRespSel()"
                  >
                    <v-btn
                      class="btn-outer pa-0"
                      slot="append"
                      color="success"
                      tile
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="light"
                      tile
                      @click="loadAddPessoa"
                    >
                      <v-icon
                        class="mx-0"
                        color="black"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="5"
                >
                  <v-text-field
                    v-if="responsavelCont"
                    v-model="responsavelCont"
                    label="Autor ou interessado"
                    outlined
                    dense
                    class="ml-n6"
                  >
                    <v-icon
                      v-if="responsavelCont"
                      slot="append"
                      color="black"
                      @click="clPessoa"
                    >
                      mdi-close
                    </v-icon>
                  </v-text-field>
                  <v-autocomplete
                    v-if="!responsavelCont"
                    v-model="filtro"
                    :items="fiscais"
                    :search-input.sync="ftpessoa"
                    cache-items
                    dense
                    outlined
                    hide-no-data
                    hide-details
                    label="Responsável"
                    class="ml-n6"
                    @change="loadRespSel()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-autocomplete
                    v-model="responsavel.uid_tipo"
                    :items="tipoFuncao"
                    label="Tipo de atribuição"
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-menu
                    v-model="menuFin"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtfin"
                        v-model="dataF_ini"
                        label="Data início.:"
                        dense
                        outlined
                        @blur="mudaDataH"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date1f"
                      @input="dateH"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-menu
                    v-model="menuFfim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtffim"
                        v-model="dataF_fim"
                        label="Data Final.:"
                        dense
                        outlined
                        @blur="mudaDataI"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date2f"
                      @input="dateI"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-card-actions class="justify-end">
            <v-btn
              color="success"
              class="mr-4"
              v-if="responsavel.id"
              type="submit"
              @click.prevent="saveResp()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-if="!responsavel.id"
              type="submit"
              @click.prevent="saveResp()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4 text-none"
              v-if="responsavel.id"
              @click="delResp"
            >
              <v-icon left>
                mdi-delete-alert-outline
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="danger"
              class="mr-4"
              @click="FecharDialogResponsavel"
            >
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Dialog dos tercerizados do contrato -->
    <v-container>
      <v-dialog
        v-model="dialogTercerizado"
        transition="dialog-top-transition"
      >
        <v-card tile>
          <v-toolbar
            color="primary"
            dark
            class="mb-2"
          >
            Adicionar ou editar tercerizado do contrato
          </v-toolbar>
          <div class="logo-foto ml-4 mt-5">
            <v-form>
              <input
                id="user-id"
                type="hidden"
                v-model="tercerizado.usuario"
              />
              <input
                id="uid_processo"
                type="hidden"
                v-model="tercerizado.uid_contrato"
              />
              <input
                id="responsavel-id"
                type="hidden"
                v-model="tercerizado.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="codTerceiro"
                    label="Código"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                  v-if="codTerceiro"
                >
                  <v-checkbox
                    v-model="tercerizado.inativar"
                    label="Inativar responsável?"
                    color="success"
                    class="mt-4"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    class="codigo mr-0"
                    v-model="tercerizado.uid_pessoa"
                    label="Código..."
                    :readonly="blokData"
                    dense
                    outlined
                    flat
                    @change="loadPessoaSel()"
                  >
                    <v-btn
                      class="btn-outer pa-0"
                      slot="append"
                      color="success"
                      tile
                      @click="loadFtPessoa"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="light"
                      tile
                      @click="loadAddPessoa"
                    >
                      <v-icon
                        class="mx-0"
                        color="black"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-autocomplete
                    v-model="filtros"
                    :items="items"
                    :search-input.sync="ftterceiro"
                    cache-items
                    dense
                    outlined
                    hide-no-data
                    hide-details
                    label="Tercerizado"
                    class="ml-n6"
                    @change="loadPessoaSel()"
                  >
                  <v-icon
                    v-if="codepessoa"
                    slot="append"
                    color="black"
                    @click="clTerceiro"
                  >
                    mdi-close
                  </v-icon>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-autocomplete
                    v-model="tercerizado.uid_lotacao"
                    :items="lotacoes"
                    clearable
                    required
                    dense
                    outlined
                    label="Lotação"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-autocomplete
                    v-model="tercerizado.uid_cargo"
                    :items="tipoFuncao"
                    required
                    dense
                    outlined
                    label="Cargo ou função"
                  >
                    <v-btn
                      class="btn-outer pa-0"
                      slot="append"
                      color="success"
                      tile
                      @click="loadFtCargo"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="light"
                      tile
                      @click="loadAddCargo"
                    >
                      <v-icon
                        class="mx-0"
                        color="black"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    v-model="tercerizado.ano"
                    label="Ano da publicação"
                    required
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    label="Matricula"
                    v-model="tercerizado.nr_matricula"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    label="Carga horária"
                    v-model="tercerizado.carga_horaria"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-checkbox
                    v-model="tercerizado.publicado"
                    label="Publicar Tercerizado?"
                    color="success"
                    v-show="mode === 'save'"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-card-actions class="justify-end">
            <v-btn
              color="success"
              class="mr-4"
              v-if="responsavel.id"
              type="submit"
              @click.prevent="saveTerceiro()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-if="!responsavel.id"
              type="submit"
              @click.prevent="saveTerceiroCont()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar e continuar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-if="!responsavel.id"
              type="submit"
              @click.prevent="saveTerceiro()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar e sair
            </v-btn>
            <v-btn
              color="error"
              class="mr-4 text-none"
              v-if="responsavel.id"
              @click="delResp"
            >
              <v-icon left>
                mdi-delete-alert-outline
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="danger"
              class="mr-4"
              @click="FecharDialogTercerizado"
            >
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar contratos
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="contratos"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadContratoFilter(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadContratoFilter(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-container>
      <v-dialog
        v-model="dialogFilter"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogFilter">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar Processos
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headerProc"
              :items="proc"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadProcesso(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadProcesso(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogFilter.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container>
      <v-dialog
        v-model="dialogAd"
        transition="dialog-bottom-transition"
      >
        <v-card tile>
          <v-toolbar
            color="primary"
            dark
            class="mb-2"
          >
            Aditivos do contrato
          </v-toolbar>
          <v-form>
            <input
              id="aditivo-id"
              type="hidden"
              v-model="aditivo.id"
            />
            <input
              id="aditivo-uuid"
              type="hidden"
              v-model="aditivo.uuid"
            />
            <input
              id="aditivo-processo"
              type="hidden"
              v-model="aditivo.uid_processo"
            />
            <input
              id="aditivo-user"
              type="hidden"
              v-model="aditivo.usuario"
            />
            <v-card class="my-6 px-4">
              <v-row>
                <v-col
                  colls="12"
                  lg="2"
                  md="4"
                  sm="12"
                >
                  <v-card-text class="py-0 mt-0">Aditivo Ant.:<h4>{{ codAditivo }}</h4>
                  </v-card-text>
                </v-col>
                <v-col
                  colls="12"
                  lg="2"
                  md="4"
                  sm="12"
                >
                  <v-card-text class="py-0 mt-0">Valor do contrato.:<h4>{{ valorCont }}</h4>
                  </v-card-text>
                </v-col>
                <v-col
                  colls="12"
                  lg="2"
                  md="4"
                  sm="12"
                >
                  <v-card-text class="py-0 mt-0">Nr. do contrato.:<h4>{{ nrCont }}</h4>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  colls="12"
                  lg="2"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    label="Número do aditivo :"
                    v-model="aditivo.nr_aditivo"
                    required
                    :readonly="mode === 'remove'"
                    dense
                    outlined
                  >
                  </v-text-field>
                  <input
                    id="aditivo-nrcont"
                    type="hidden"
                    v-model="aditivo.uid_processo"
                  />
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="6"
                  sm="12"
                >
                  <v-autocomplete
                    v-if="mode === 'save'"
                    label="Tipo de aditivo:"
                    v-model="aditivo.uid_tipo_aditivo"
                    :items="tpaditivo"
                    clearable
                    dense
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="6"
                  sm="12"
                >
                  <v-autocomplete
                    v-if="mode === 'save'"
                    label="Tipo de alteração de valor:"
                    v-model="aditivo.uid_tipo_valor"
                    :items="tpvalor"
                    clearable
                    dense
                    outlined
                    @change="loadClearCalc"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  colls="12"
                  lg="2"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    label="Ano do aditivo :"
                    v-model="aditivo.ano_aditivo"
                    required
                    :readonly="mode === 'remove'"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                  lg="3"
                >
                  <v-menu
                    v-model="menuA"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtpubA"
                        v-model="publicacaoA"
                        label="Data assinatura.:"
                        dense
                        outlined
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date1A"
                      @input="datePubA"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  lg="3"
                >
                  <v-menu
                    v-model="menupA"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtpubpA"
                        v-model="publicacaopA"
                        label="Data Publicação.:"
                        dense
                        outlined
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date1pA"
                      @input="datePubpA"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  lg="3"
                >
                  <v-menu
                    v-model="menu1A"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtiniA"
                        v-model="inicioA"
                        label="Data início.:"
                        dense
                        outlined
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date2A"
                      @input="dateInA"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  lg="3"
                >
                  <v-menu
                    v-model="menu2A"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dttemA"
                        v-model="terminoA"
                        label="Data término.:"
                        dense
                        outlined
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date3A"
                      @input="dateFimA"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                  sm="12"
                >
                  <v-currency-field
                    v-if="mode === 'save'"
                    v-model="aditivo.valor_aditivo"
                    label="Valor do aditivo :"
                    dense
                    outlined
                    @change="loadFuncaoCalc()"
                  >
                  </v-currency-field>
                  <input
                    id="val_atualizado"
                    type="hidden"
                    v-model="aditivo.valor_atualizado"
                  />
                </v-col>
                <v-col
                  colls="12"
                  lg="2"
                  md="4"
                  sm="12"
                >
                  <v-card-text class="py-0 mt-0">Valor atualizado.:<h4>{{ valorAtualizado }}</h4>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  colls="12"
                  lg="12"
                  md="12"
                  sm="12"
                >
                  <v-textarea
                    v-model="aditivo.observacao"
                    label="Observações.:"
                    rows="3"
                    dense
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
          <v-card-actions class="justify-center">
            <v-btn
              color="success"
              class="mr-4"
              v-if="codigo"
              type="submit"
              @click="adicionarAditivo"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Adicionar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="codigo"
              @click="resetAditivos"
            >
              Limpar
              <v-icon left>
                mdi-broom
              </v-icon>
            </v-btn>
            <v-btn
              color="danger"
              class="mr-4"
              @click="fechaDialogAditivo"
            >
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container>
      <v-dialog
        v-model="DialogAnexo"
        transition="dialog-top-transition"
      >
        <v-card tile>
          <v-toolbar
            color="primary"
            dark
            class="mb-2"
          >
            Adicionar anexos ao processo
          </v-toolbar>
          <div class="ml-4 mt-5">
            <v-form>
              <input
                id="user-id"
                type="hidden"
                v-model="anexo.usuario"
              />
              <input
                id="anexo-id"
                type="hidden"
                v-model="anexo.id"
              />
              <v-row>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="idAnexo"
                    label="Cod. anexo"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  lg="4"
                >
                  <v-text-field
                    v-model="anexo.nome"
                    type="text"
                    label="Nome do arquivo"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                >
                  <v-autocomplete
                    label="Tipo de documento:"
                    v-model="anexo.uid_cat_doc"
                    :items="tpAnexos"
                    dense
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  lg="3"
                >
                  <v-menu
                    v-model="menu6"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="datanex"
                        v-model="data_anex"
                        label="Data de publicação.:"
                        dense
                        outlined
                        @blur="mudaDataG"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date6"
                      @input="dateG"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="4"
                >
                  <v-checkbox
                    label="Inativar ítem?"
                    color="success"
                    v-show="mode === 'save'"
                    class="mt-4"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row v-if="!idAnexo">
                <input
                  accept="application/vnd.ms-excel, application/pdf"
                  prepend-icon="mdi-camera"
                  label="Anexo"
                  v-if="uploadReady"
                  type="file"
                  ref="file"
                  @change="selectFile()"
                >
              </v-row>
            </v-form>
          </div>
          <v-card-actions class="justify-end">
            <v-btn
              color="success"
              class="mr-4"
              v-if="!idAnexo"
              type="submit"
              @click.prevent="fileUpload()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4"
              v-if="idAnexo"
              type="submit"
              @click.="editAnexo()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="!idAnexo"
              @click="clearUpload"
            >
              Limpar
              <v-icon left>
                mdi-broom
              </v-icon>
            </v-btn>
            <v-btn
              color="danger"
              class="mr-4"
              @click="FecharDialog"
            >
              Sair
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Dialog cadastro de cargos e funções -->
      <v-container>
        <v-dialog
          v-model="dialogCargo"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar cargos e funções
            </v-toolbar>
            <v-form ref="form">
              <Cargos />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="closeDialog"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog cadastro de pessoa -->
      <v-container>
        <v-dialog
          v-model="DialogPessoa"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar Pessoa
            </v-toolbar>
            <v-form ref="form">
              <Cadastro :btnsair="btnsair" />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="closeDialogPessoa"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Modal de confirmação remove tercerizado-->
      <v-dialog v-model="dialogRmTercerizado" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover.:{{ tercerizadoNome }}?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmTercerizado = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removeTercerizadoConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import Cadastro from '@/modules/admin/cadastros/pessoas'
import Cargos from '@/modules/cadastros/components/cargos'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'Contrato',
  components: { Cargos, Cadastro },
  computed: mapState(['user']),
  data: () => ({
    dtpub: '##/##/####',
    datanex: '##/##/####',
    dtass: '##/##/####',
    dtini: '##/##/####',
    dttem: '##/##/####',
    dtpubA: '##/##/####',
    dtpubpA: '##/##/####',
    dtiniA: '##/##/####',
    dttemA: '##/##/####',
    dtfin: '##/##/####',
    dtffim: '##/##/####',
    loading: false,
    blokData: false,
    mode: 'save',
    uuid: '',
    codigo: '',
    anoBusca: '',
    exercicio: null,
    codResp: '',
    codTerceiro: '',
    idAnexo: '',
    codProc: '',
    ativo: '',
    responsavelCont: '',
    responsavelCod: '',
    dialog: false,
    dialogResponsavel: false,
    dialogTercerizado: false,
    dialogRmTercerizado: false,
    dialogFilter: false,
    dialogCargo: false,
    DialogPessoa: false,
    dialogAd: false,
    DialogAnexo: false,
    filtro: null,
    filtros: null,
    select: null,
    ftpessoa: null,
    ftterceiro: null,
    search: null,
    tabs: null,
    date1: '',
    date1As: '',
    date2: '',
    date3: '',
    date1A: '',
    date1pA: '',
    date2A: '',
    date3A: '',
    date6: '',
    date1f: '',
    date9: '',
    date10: '',
    date2f: '',
    data_anex: '',
    dataF_ini: '',
    dataF_fim: '',
    assinatura: '',
    publicacao: '',
    codepessoa: '',
    inicio: '',
    termino: '',
    uploadReady: true,
    file: '',
    arquivo: '',
    tabela: 'licitanexos',
    menuAs: false,
    menu: false,
    menu1: false,
    menu2: false,
    menuA: false,
    menupA: false,
    menu1A: false,
    menu2A: false,
    menu6: false,
    menu9: false,
    menu10: false,
    menuFin: false,
    menuFfim: false,
    tercerizadoSelecionado: null,
    tercerizadoNome: null,
    listar: '',
    valorAtualizado: '[Não Informado]',
    valorCont: '[Não Informado]',
    codAditivo: '[Não Informado]',
    nrCont: '[Não Informado]',
    contrato: {},
    processo: {},
    sync: {},
    aditivo: {},
    fornecedor: {},
    anexo: {},
    responsavel: {},
    valor: 0,
    val: 0,
    items: [],
    contratos: [],
    fiscais: [],
    fiscal: {},
    pessoa: {},
    tercerizado: {},
    modalidade: [],
    lotacoes: [],
    tpaditivo: [],
    tpvalor: [],
    anexos: [],
    tpAnexos: [],
    aditivoItems: [],
    tpContrato: [],
    gestao: [],
    gestCompra: [],
    ajuste: [],
    proc: [],
    tercerizados: [],
    tipoFuncao: [],
    headerProc: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Processo todo compra', value: 'proc_compra' },
      { text: 'Processo', value: 'processo' },
      { text: 'Gestao', value: 'gestao' },
      { text: 'Licitacao', value: 'licitacao' },
      { text: 'Ano', value: 'ano', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Id Prodata', value: 'idProdata' },
      { text: 'Processo compra', value: 'nr_processo' },
      { text: 'Nº do contrato', value: 'nr_contrato' },
      { text: 'Ano', value: 'ano' },
      { text: 'Contratado', value: 'fornecedor' },
      { text: 'Valor', value: 'valor_total' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAditivos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nº do aditivo', value: 'nr_aditivo' },
      { text: 'Assinatura', value: 'assinatura' },
      { text: 'Ano', value: 'ano_aditivo' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Valor', value: 'valor_aditivo' },
      { text: 'Valor atualizado', value: 'valor_atualizado' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerAnexo: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Processo comp', value: 'uid_processo' },
      { text: 'Publicação', value: 'publicacao' },
      { text: 'Nome do arquivo', value: 'nome' },
      { text: 'Url', value: 'url' },
      { text: 'Tamanho', value: 'size' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerResponsaveis: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Função', value: 'cargo' },
      { text: 'Data inicial', value: 'inicio' },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerTercerizados: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome_tercerizado' },
      { text: 'Órgão', value: 'orgao' },
      { text: 'Função', value: 'cargo' },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    // tipoResp: [
    //   { value: 1, text: 'Fiscal do Contrato' },
    //   { value: 2, text: 'Gestor do Contrato' },
    //   { value: 3, text: 'Assinatura do contrato' }
    // ],
    vcontrato: 0
  }),
  watch: {
    ftpessoa (val) {
      val && val !== this.filtro && this.querySelectionsResponsavel(val)
    },
    ftterceiro (val) {
      val && val !== this.filtros && this.querySelectionsTerceiro(val)
    }
  },
  methods: {
    querySelectionsResponsavel (v) {
      const fpessoa = v || 0
      const url = `${baseApiUrl}/funcoes-especiais-select/${fpessoa}`
      axios.get(url).then(res => {
        this.fiscais = res.data.map(item => {
          return {
            value: item.id,
            text: item.nome
          }
        })
      })
    },
    querySelectionsTerceiro (v) {
      const fterceiro = v || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${fterceiro}`
      axios.get(url).then(res => {
        this.items = res.data.map(item => {
          return {
            value: item.uid_pessoa,
            text: item.razao
          }
        })
      })
    },
    dateAss () {
      this.assinatura = moment(this.date1As).format('DD/MM/YYYY')
      this.menuAs = false

      if (!this.assinatura) return

      const dateFIRM = moment(this.date1As, 'DD/MM/YYYY', true)
      if (!dateFIRM.isValid()) return

      this.contrato.dt_firmatura2 = dateFIRM.format('YYYY-MM-DD')
    },
    datePub () {
      this.publicacao = moment(this.date1).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.publicacao.split('/')
      this.contrato.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    // dateIn () {
    //   this.inicio = moment(this.date2).format('DD/MM/YYYY')
    //   this.menu1 = false
    //   const [dia, mes, ano] = this.inicio.split('/')
    //   this.contrato.inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    // },
    dateIn () {
      this.inicio = moment(this.date2).format('DD/MM/YYYY')
      this.menu1 = false

      if (!this.inicio) return

      const dateIN = moment(this.date2, 'DD/MM/YYYY', true)
      if (!dateIN.isValid()) return

      this.contrato.inicio_vigencia = dateIN.format('YYYY-MM-DD')
    },
    dateFim () {
      this.termino = moment(this.date3).format('DD/MM/YYYY')
      this.menu2 = false

      if (!this.termino) return

      const dateFIM = moment(this.date3, 'DD/MM/YYYY', true)
      if (!dateFIM.isValid()) return

      this.contrato.final_vigencia = dateFIM.format('YYYY-MM-DD')
    },
    datePubA () {
      this.publicacaoA = moment(this.date1A).format('DD/MM/YYYY')
      this.menuA = false

      if (!this.publicacaoA) return

      const dateFIRM = moment(this.date1A, 'DD/MM/YYYY', true)
      if (!dateFIRM.isValid()) return

      this.contrato.dt_firmatura2 = dateFIRM.format('YYYY-MM-DD')
    },
    datePubpA () {
      this.publicacaopA = moment(this.date1pA).format('DD/MM/YYYY')
      this.menupA = false
      const [dia, mes, ano] = this.publicacaopA.split('/')
      this.aditivo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateInA () {
      this.inicioA = moment(this.date2A).format('DD/MM/YYYY')
      this.menu1A = false
      const [dia, mes, ano] = this.inicioA.split('/')
      this.aditivo.inicio_aditivo = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateFimA () {
      this.terminoA = moment(this.date3A).format('DD/MM/YYYY')
      this.menu2A = false
      const [dia, mes, ano] = this.terminoA.split('/')
      this.aditivo.termino_aditivo = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateG () {
      this.data_anex = moment(this.date6).format('DD/MM/YYYY')
      this.menu6 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataG () {
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateH () {
      this.dataF_ini = moment(this.date1f).format('DD/MM/YYYY')
      this.menuFin = false
      const [dia, mes, ano] = this.dataF_ini.split('/')
      this.responsavel.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataH () {
      const [dia, mes, ano] = this.dataF_ini.split('/')
      this.responsavel.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateI () {
      this.dataF_fim = moment(this.date2f).format('DD/MM/YYYY')
      this.menuFfim = false
      const [dia, mes, ano] = this.dataF_fim.split('/')
      this.responsavel.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataI () {
      const [dia, mes, ano] = this.dataF_fim.split('/')
      this.responsavel.data_fim = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataJ () {
      const [dia, mes, ano] = this.data_ini.split('/')
      if (this.data_ini) {
        this.sync.dataInicial = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateJ () {
      this.data_ini = moment(this.date9).format('DD/MM/YYYY')
      this.menu9 = false
      const [dia, mes, ano] = this.data_ini.split('/')
      this.sync.dataInicial = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataK () {
      const [dia, mes, ano] = this.data_fim.split('/')
      if (this.data_fim) {
        this.sync.dataFinal = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateK () {
      this.data_fim = moment(this.date10).format('DD/MM/YYYY')
      this.menu10 = false
      const [dia, mes, ano] = this.data_fim.split('/')
      this.sync.dataFinal = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    limpaBox () {
      this.dataTeste = ''
      console.log(this.dataTeste + '..: data')
    },
    save () {
      const method = this.contrato.id ? 'put' : 'post'
      const id = this.contrato.id ? `/${this.contrato.id}` : ''
      axios[method](`${baseApiUrl}/tc-contratos${id}`, this.contrato)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    syncDados () {
      //  this.sync.contribuinte = this.divida.contribuinte
      //  this.sync.dataIncial = this.date0
      //  this.sync.dataFinal = this.date2
      const method = 'post'
      axios[method](`${baseApiUrl}/carga-prodata-contratos-sync`, this.sync)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },

    adicionarAditivo () {
      const method = this.aditivo.id ? 'put' : 'post'
      const id = this.aditivo.id ? `/${this.aditivo.id}` : ''
      axios[method](`${baseApiUrl}/tc-aditivos${id}`, this.aditivo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetAditivos()
          this.loadAditivos()
          this.dialogAd = false
        })
        .catch(showError)
    },
    saveResp () {
      const method = this.responsavel.id ? 'put' : 'post'
      const id = this.responsavel.id ? `/${this.responsavel.id}` : ''
      axios[method](`${baseApiUrl}/responsaveis-de-contratos${id}`, this.responsavel)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadFiscais()
          this.clearAutor()
          this.dialogResponsavel = false
        })
        .catch(showError)
    },
    delResp () {
      if (confirm('Deseja realmente remover o responsável?')) {
        const method = 'delete'
        const id = this.responsavel.id
        axios[method](`${baseApiUrl}/responsaveis-de-contratos/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.responsavel = {}
            this.loadFiscais()
            this.dialogResponsavel = false
          })
          .catch(showError)
      }
    },
    saveTerceiros () {
      const method = this.tercerizado.id ? 'put' : 'post'
      const id = this.tercerizado.id ? `/${this.tercerizado.id}` : ''
      axios[method](`${baseApiUrl}/tercerizados${id}`, this.tercerizado)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTerceiros()
          this.tercerizado = {}
          this.contTerceiro()
        })
        .catch(showError)
    },
    removeTercerizadoConfirmado () {
      const id = this.tercerizadoSelecionado
      axios.delete(`${baseApiUrl}/tercerizados/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTerceiros()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmTercerizado = false
          this.tercerizadoSelecionado = null
          this.tercerizadoNome = null
        })
    },
    confirmRemove (item) {
      this.tercerizadoSelecionado = item.id
      this.tercerizadoNome = item.nome_tercerizado
      this.dialogRmTercerizado = true
    },
    editAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos-de-processos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
          this.limpar()
        })
        .catch(showError)
    },
    delDocs (item) {
      if (confirm('Deseja realmente deletar este auquivo?')) {
        const id = item.id
        const url = `${baseApiUrl}/anexos-de-processos/${id}`
        axios.delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadAnexos()
          })
          .catch(showError)
      }
    },
    delAditivo (item) {
      if (confirm('Deseja realmente deletar este aditivo?')) {
        const id = item.id
        const url = `${baseApiUrl}/tc-aditivos/${id}`
        axios.delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadAditivos()
          })
          .catch(showError)
        // } else {
      }
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_processo', this.contrato.nr_processo)
      formData.append('uid_contrato', this.contrato.id)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.contrato.ano)
      formData.append('subpasta', this.contrato.nr_processo)
      formData.append('uid_cat_doc', this.anexo.uid_cat_doc)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadAnexos()
          this.data_anex = ''
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.anexo = {}
      this.file = ''
    },
    resetUpload () {
      this.anexo = {}
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    loadFilter () {
      const exercicio = this.anoBusca || null
      axios.get(`${baseApiUrl}/tc-contratos-filtro`, {
        params: { exercicio }
      })
      .then(res => {
        this.contratos = res.data
      })
      .finally(() => {
          this.anoBusca = ''
          this.exercicio = null
        })
    },
    loadContratoFilter (item) {
      const id = item.id
      this.codigo = item.id
      this.codProc = item.nr_processo
      const url = `${baseApiUrl}/tc-contratos/${id}`
      axios.get(url).then(res => {
        this.contrato = res.data
        // if (!this.contrato.data_assinatura) {
        //   this.assinatura = ''
        // } else {
        //   this.assinatura = moment(this.contrato.data_assinatura).format('DD/MM/YYYY')
        //   this.contrato.data_assinatura = moment(this.contrato.data_assinatura).format('YYYY-MM-DD')
        // }
        if (!this.contrato.data_publicacao) {
          this.publicacao = ''
        } else {
          this.publicacao = moment(this.contrato.data_publicacao).format('DD/MM/YYYY')
          this.contrato.data_publicacao = moment(this.contrato.data_publicacao).format('YYYY-MM-DD')
        }
        // if (!this.contrato.inicio) {
        //   this.inicio = ''
        // } else {
        //   this.inicio = moment(this.contrato.inicio).format('DD/MM/YYYY')
        //   this.contrato.inicio = moment(this.contrato.inicio).format('YYYY-MM-DD')
        // }
        this.assinatura = moment(this.contrato.dt_firmatura).format('DD/MM/YYYY')
        this.inicio = moment(this.contrato.inicio_vigencia).format('DD/MM/YYYY')
        this.termino = moment(this.contrato.final_vigencia).format('DD/MM/YYYY')
        // if (!this.contrato.termino) {
        //   this.termino = ''
        // } else {
        //   this.termino = moment(this.contrato.termino).format('DD/MM/YYYY')
        //   this.contrato.termino = moment(this.contrato.termino).format('YYYY-MM-DD')
        // }
      })
      this.dialog = false
      this.search = ''
    },
    loadFilterProc () {
      const url = `${baseApiUrl}/tc-licitacoes-filtro`
      axios.get(url).then(res => {
        this.proc = res.data
      })
    },
    loadProcesso (proc, mode = 'save') {
      const id = this.codProc ? this.codProc : proc.proc_compra
      const url = `${baseApiUrl}/tc-licitacoes/${id}`
      axios.get(url).then(res => {
        this.processo = res.data
        this.codProc = this.processo.proc_compra
        this.contrato.uid_processo = this.processo.id
        this.contrato.nr_processo = this.processo.proc_compra
        this.contrato.uid_gestao = this.processo.uid_gestao
        this.contrato.uid_modal_licitacao = this.processo.uid_modal
        this.contrato.nr_licitacao = this.processo.licitacao
        this.contrato.ano_licitacao = this.processo.ano
        this.contrato.ds_razao_escolha_fornecedor = this.processo.ds_razao_escolha_fornecedor
        this.situacao = this.processo.situacao
      })
      this.dialogFilter = false
    },
    loadPedidoPessoaId (item) {
      const id = this.contrato.uid_pessoa ? `/${this.contrato.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.fornecedor = res.data
        this.contrato.uid_pessoa = this.fornecedor.uid_pessoa
        this.contrato.razao_fornecedor = this.fornecedor.razao
      })
      this.clPessoa()
    },
    clPessoa () {
      this.fornecedor = {}
      this.items = []
      this.pessoa = {}
      this.fiscais = []
      this.autor = {}
      this.responsavelCod = ''
      this.responsavelCont = ''
      this.contrato.uid_pessoa = ''
      this.contrato.razao_fornecedor = ''
      this.listar = ''
    },
    loadLicitacao () {
      this.loadModalidade()
    },
    loadSeach (listar = 'sim') {
      const search = this.contrato.razao_fornecedor || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    reset () {
      this.mode = 'save'
      this.aditivoItems = []
      this.responsaveis = []
      this.contrato = {}
      this.codigo = ''
      this.blokData = false
      this.codProc = ''
      this.assinatura = ''
      this.publicacao = ''
      this.inicio = ''
      this.termino = ''
      // this.fornec = {}
      // this.items = []
      this.contrato.uuid = uuid.v1()
      //            this.loadcontratos()
      this.loadDatas()
    },
    limpar () {
      this.idAnexo = ''
      this.anexo = {}
      this.clearUpload()
    },
    resetAditivos () {
      this.aditivo = {}
      this.publicacaoA = ''
      this.publicacaopA = ''
      this.inicioA = ''
      this.terminoA = ''
    },
    saveTerceiro () {
      this.saveTerceiros()
      this.dialogTercerizado = false
      this.clTerceiro()
    },
    saveTerceiroCont () {
      this.saveTerceiros()
      this.codepessoa = ''
      this.filtros = null
      this.items = []
      this.tercerizado.uid_pessoa = ''
      this.tercerizado.nome_tercerizado = ''
      this.pessoa = {}
    },
    contTerceiro () {
      this.tercerizado.usuario = this.user.id
      this.tercerizado.uid_contrato = this.contrato.id
      this.tercerizado.uid_orgao = this.contrato.orgao
      if (this.contrato.inicio_vigencia) {
        this.tercerizado.inicio = moment(this.contrato.inicio_vigencia).format('YYYY-MM-DD')
      }
      if (this.contrato.final_vigencia) {
        this.tercerizado.termino = moment(this.contrato.final_vigencia).format('YYYY-MM-DD')
      }
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {
      this.DialogPessoa = true
    },
    loadFtCargo () {

    },
    loadAddCargo () {
      this.dialogCargo = true
    },
    closeDialog () {
      this.dialogCargo = false
      this.loadCargos()
    },
    loadClearCalc () {
      this.aditivo.valor_aditivo = ''
      this.loadFuncaoCalc()
    },
    loadFuncaoCalc () {
      const vcont = this.contrato.valor
      const vtot = this.contrato.valor_total
      if (vtot === 0) {
        this.vcontrato = vcont
      } else {
        this.vcontrato = vtot
      }
      const valAditivo = this.aditivo.valor_aditivo
      const vAtualizado = this.vcontrato
      const tValor = this.aditivo.uid_tipo_valor
      if (!tValor) {
        alert('Selecione um tipo de valor!')
      } else {
        if (tValor === 1 || tValor === 3) {
          this.val = (parseFloat(valAditivo) + parseFloat(vAtualizado))
        } else if (tValor === 4 || tValor === 6) {
          this.val = (parseFloat(vAtualizado) - parseFloat(valAditivo))
        } else {
          this.val = vAtualizado
        }
      }
      this.valorAtualizado = this.val

      //  this.val = (parseFloat(valAditivo) + parseFloat(vAtualizado));
      this.valor = this.val.toFixed(2)
      this.aditivo.valor_atualizado = this.valor
    },
    loadAnexos () {
      const id = this.contrato.id
      const url = `${baseApiUrl}/anexos-de-contratos/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadAnexo (item) {
      const id = item.id
      const url = `${baseApiUrl}/anexos-de-processos/${id}`
      axios.get(url).then(res => {
        this.anexo = res.data
        this.idAnexo = this.anexo.id
        if (!this.anexo.data_publicacao) {
          this.data_anex = ''
        } else {
          this.data_anex = moment(this.anexo.data_publicacao).format('DD/MM/YYYY')
          this.anexo.data_publicacao = moment(this.anexo.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.loadModalAnexo()
    },
    loadModalAnexo () {
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.anexo = {}
      this.data_anex = ''
      this.limpar()
    },
    FecharDialogResponsavel () {
      this.dialogResponsavel = false
      this.responsavel = {}
      this.dataF_fim = ''
      this.dataF_ini = ''
      this.responsavelCod = ''
      this.responsavelCont = ''
      this.codResp = ''
    },
    FecharDialogTercerizado () {
      this.dialogTercerizado = false
      this.responsavel = {}
      this.dataF_fim = ''
      this.dataF_ini = ''
      this.responsavelCod = ''
      this.responsavelCont = ''
      this.codTerceiro = ''
    },
    loadFuncao () {
      const cont = this.contrato.uid_paralizacao
      if (cont === 1) {
        this.ativo = 'paralizacao'
        this.contrato.uid_motivo_rescisao = null
        this.contrato.uid_tipo_rescisao = null
        this.contrato.data_rescisao = null
      } else if (cont === 2) {
        this.ativo = 'rescisao'
        this.contrato.inicio_paralizacao = null
        this.contrato.termino_paralizacao = null
      } else {
        this.ativo = ''
      }
    },
    loadAditivos () {
      const id = this.contrato.id
      const url = `${baseApiUrl}/tc-aditivos-contrato/${id}`
      axios.get(url).then(res => {
        this.aditivoItems = res.data.map(item => {
          return {
            ...item,
            assinatura: moment(item.data_assinatura).format('DD/MM/YYYY')
          }
        })
      })
    },
    // loadAditivo (aditivo, mode = 'save') {
    //   this.mode = mode
    //   this.aditivo = { ...aditivo }
    //   this.novo = false
    //   this.$refs['add-aditivos'].show()
    // },
    loadGestoes () {
      const url = `${baseApiUrl}/gestoes`
      axios.get(url).then(res => {
        this.gestao = res.data.map(gestao => {
          return { value: gestao.orgao, text: `${gestao.orgao} - ${gestao.gestao}` }
        })
      })
    },
    loadGestaoContrato () {
      const url = `${baseApiUrl}/gestoes`
      axios.get(url).then(res => {
        this.gestCompra = res.data.map(gestao => {
          return { value: gestao.cod_gestao, text: `${gestao.cod_gestao} - ${gestao.gestao}` }
        })
      })
    },
    // -- Bloco responsável contrato (fiscal)
    loadEditResponsavel (item) {
      const id = item.id
      const url = `${baseApiUrl}/responsaveis-de-contratos/${id}`
      axios.get(url).then(res => {
        this.responsavel = res.data
        this.codResp = this.responsavel.id
        this.responsavelCod = this.responsavel.id
        this.responsavelCont = this.responsavel.nome
        if (this.responsavel.data_inicio) {
          this.dataF_ini = moment(this.responsavel.data_inicio).format('DD/MM/YYYY')
          this.responsavel.data_inicio = moment(this.responsavel.data_inicio).format('YYYY-MM-DD')
        } else {
          this.dataF_ini = ''
        }
        if (this.responsavel.data_fim) {
          this.dataF_fim = moment(this.responsavel.data_fim).format('DD/MM/YYYY')
          this.responsavel.data_fim = moment(this.responsavel.data_fim).format('YYYY-MM-DD')
        } else {
          this.dataF_fim = ''
        }
      })
      this.dialogResponsavel = true
    },
    loadModalResponsavel () {
      this.responsavel.usuario = this.user.id
      this.responsavel.uid_contrato = this.contrato.id
      this.dialogResponsavel = true
    },
    loadModalTercerizado () {
      this.tercerizado.usuario = this.user.id
      this.tercerizado.uid_contrato = this.contrato.id
      this.tercerizado.uid_orgao = this.contrato.orgao
      if (this.contrato.inicio_vigencia) {
        this.tercerizado.inicio = moment(this.contrato.inicio_vigencia).format('YYYY-MM-DD')
      }
      if (this.contrato.final_vigencia) {
        this.tercerizado.termino = moment(this.contrato.final_vigencia).format('YYYY-MM-DD')
      }
      this.dialogTercerizado = true
      this.loadLotacao()
      this.loadCargos()
    },
    loadRespSel () {
      const item = this.filtro
      const id = this.responsavelCod ? `/${this.responsavelCod}` : `/${item}`
      const url = `${baseApiUrl}/funcoes-especiais${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.responsavel.uid_pessoa = this.pessoa.id
        this.responsavel.uid_tipo = this.pessoa.uid_tipo
        this.responsavelCod = this.pessoa.id
        this.responsavelCont = this.pessoa.nome
        this.disabled = true
      })
      //  this.clPessoa()
    },
    loadPessoaSel () {
      const item = this.filtros
      const id = this.tercerizado.uid_pessoa ? `/${this.tercerizado.uid_pessoa}` : `/${item}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.tercerizado.uid_pessoa = this.pessoa.uid_pessoa
        this.tercerizado.nome_tercerizado = this.pessoa.razao
        this.tercerizado.cpf = this.pessoa.cpf_txt ? String(this.pessoa.cpf_txt).substr(0, 3) + '.***.***-' + String(this.pessoa.cpf_txt).substr(12, 2) : '***.***.***-**'
        this.codepessoa = this.pessoa.uid_pessoa
      })
    },

    clTerceiro () {
      this.codepessoa = ''
      this.filtros = null
      this.items = []
      this.tercerizado.uid_pessoa = ''
      this.tercerizado.nome_tercerizado = ''
      this.pessoa = {}
    },
    loadPesoasFilter () {
      const url = `${baseApiUrl}/filtro-pessoas`
      axios.get(url).then(res => {
        this.pessoas = res.data
      })
    },
    loadLotacao () {
      const url = `${baseApiUrl}/lista-unidade-for-select`
      axios.get(url).then(res => {
        this.lotacoes = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.tipoFuncao = res.data.map(item => {
          return {
            value: item.id,
            text: item.cargo
          }
        })
      })
    },
    loadResponsaveis () {
      const id = this.contrato.id
      const url = `${baseApiUrl}/responsaveis-por-contratos/${id}`
      axios.get(url).then(res => {
        this.responsaveis = res.data.map(item => {
          return {
            ...item,
            status: item.inativar === 0 ? 'Ativo' : 'Inativo',
            inicio: moment(item.data_inicio).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadTercerizados () {
      const id = this.contrato.id
      const url = `${baseApiUrl}/tercerizados-do-contrato/${id}`
      axios.get(url).then(res => {
        this.tercerizados = res.data.map(item => {
          return {
            ...item,
            status: item.inativar === 0 ? 'Ativo' : 'Inativo',
          }
        })
        console.log('active')
      })
    },
    clearAutor () {
      this.responsavel = {}
      this.fiscal = {}
      this.responsaveis = []
      this.dataF_fim = ''
      this.dataF_ini = ''
      this.responsavelCod = ''
      this.responsavelCont = ''
    },
    // ---- Fim do Bloco de responsáveis(fisal)
    loadModalidade () {
      const url = `${baseApiUrl}/modalidades`
      axios.get(url).then(res => {
        this.modalidade = res.data.map(modalidade => {
          return {
            value: modalidade.id,
            text: `${modalidade.modalidade}`
          }
        })
      })
    },
    loadAjuste () {
      const url = `${baseApiUrl}/tipo-de-ajuste`
      axios.get(url).then(res => {
        this.ajuste = res.data.map(item => {
          return { value: item.id, text: `${item.ajuste}` }
        })
      })
    },
    loadTipoContrato () {
      const url = `${baseApiUrl}/tipo-de-contratos`
      axios.get(url).then(res => {
        this.tpContrato = res.data.map(item => {
          return { value: item.id, text: item.tipo_contrato }
        })
      })
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.tpAnexos = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadModalAditivo () {
      this.aditivo = {}
      this.novo = true
      this.nrCont = this.contrato.nr_contrato
      this.valorCont = this.contrato.valor
      this.valorAtualizado = this.aditivo.valor_atualizado
      this.aditivo.usuario = this.user.id
      this.aditivo.uuid = uuid.v1()
      this.nr_aditivo = this.contrato.nr_aditivo + 1
      this.aditivo.uid_contrato = this.contrato.id
      this.aditivo.uid_processo = this.contrato.uid_processo
      this.aditivo.nr_processo = this.contrato.nr_processo
      this.aditivo.nr_contrato = this.contrato.nr_contrato
      this.dialogAd = true
      this.loadTpValor()
      this.loadTpAditivos()
    },
    loadAditivo (item) {
      const id = item.id
      const url = `${baseApiUrl}/tc-aditivos/${id}`
      axios.get(url).then(res => {
        this.aditivo = res.data
        this.codAditivo = this.contrato.nr_aditivo
        this.nrCont = this.contrato.nr_contrato
        this.valorCont = this.contrato.valor
        this.valorAtualizado = this.aditivo.valor_atualizado
        this.loadDataAditivo()
      })
    },
    loadDataAditivo () {
      if (this.aditivo.termino_aditivo) {
        this.terminoA = moment(this.aditivo.termino_aditivo).format('DD/MM/YYYY')
        this.aditivo.termino_aditivo = moment(this.aditivo.termino_aditivo).format('YYYY-MM-DD')
      } else {
        this.terminoA = ''
      }
      if (this.aditivo.inicio_aditivo) {
        this.inicioA = moment(this.aditivo.inicio_aditivo).format('DD/MM/YYYY')
        this.aditivo.inicio_aditivo = moment(this.aditivo.inicio_aditivo).format('YYYY-MM-DD')
      } else {
        this.inicioA = ''
      }
      if (this.aditivo.data_assinatura) {
        this.publicacaoA = moment(this.aditivo.data_assinatura).format('DD/MM/YYYY')
        this.aditivo.data_assinatura = moment(this.aditivo.data_assinatura).format('YYYY-MM-DD')
      } else {
        this.publicacaoA = ''
      }
      if (this.aditivo.data_publicacao) {
        this.publicacaopA = moment(this.aditivo.data_publicacao).format('DD/MM/YYYY')
        this.aditivo.data_publicacao = moment(this.aditivo.data_publicacao).format('YYYY-MM-DD')
      } else {
        this.publicacaopA = ''
      }

      this.dialogAd = true
      this.loadTpValor()
      this.loadTpAditivos()
    },
    fechaDialogAditivo () {
      this.dialogAd = false
      this.nrCont = '[Não Informado]'
      this.valorCont = '[Não Informado]'
      this.valorAtualizado = '[Não Informado]'
      this.codAditivo = '[Não Informado]'
    },
    loadTpAditivos () {
      const url = `${baseApiUrl}/tipo-de-aditivos`
      axios.get(url).then(res => {
        this.tpaditivo = res.data.map(tpaditivo => {
          return { value: tpaditivo.id, text: `${tpaditivo.tipo_aditivo}` }
        })
      })
    },
    loadTpValor () {
      const url = `${baseApiUrl}/tipo-de-valor`
      axios.get(url).then(res => {
        this.tpvalor = res.data.map(tpvalor => {
          return { value: tpvalor.id, text: `${tpvalor.tipo_valor}` }
        })
      })
    },
    closeDialogPessoa () {
      this.DialogPessoa = false
    },
    loadDialog () {
      this.dialog = true
      this.ativo = ''
      this.loadFilter()
    },
    loadModalProc () {
      this.dialogFilter = true
      this.loadFilterProc()
    },
    loadFiscais () {
      this.loadResponsaveis()
      this.loadCargos()
    },
    loadTerceiros () {
      this.loadTercerizados()
      this.loadCargos()
    },
    loadDatas () {
      // const dataAgora = new Date().toISOString().substr(0, 10)
      // this.data_publicacao = moment(dataAgora).format('DD/MM/YYYY')
      // this.date1 = dataAgora
      // this.contrato.data_publicacao = dataAgora
      this.contrato.data_publicacao = ''
      this.contrato.inicio = ''
      this.contrato.termino = ''
    },
    loadUsers () {
      this.contrato.usuario = this.user.id
      this.user_anexo = this.user.id
    }
  },
  //  watch: {
  //    getGornec() {
  //      this.printPessoa()
  //    }
  //  },
  mounted () {
    this.loadUsers()
    this.loadGestoes()
    this.loadGestaoContrato()
    this.loadAjuste()
    this.loadTipoContrato()
    //  this.loadModalidade()
    //  this.loadParalizacao()
    //  this.loadRescisao()
    //  this.loadMotivo()
    this.contrato.uuid = uuid.v1()
  }
}
</script>

<style scoped>
.form-tabs {
  background-color: #f0eceaf3;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
</style>
